import { get } from 'utils/lodash';

export const sortByKey = (arr, key) => {
  const newArr = [...arr].sort((itemA, itemB) => {
    if (get(itemA, key) === get(itemB, key)) {
      return 0;
    }

    return get(itemA, key) > get(itemB, key) ? 1 : -1;
  });

  return newArr;
};
